export enum LocationType {
	"KUWAIT_FORECAST" = "kuwait-forecast",
	"MARINE_FORECAST" = "marine-forecast",
	"WORLD_FORECAST" = "world-forecast",
}
